import { render, staticRenderFns } from "./theme.vue?vue&type=template&id=51791272&scoped=true&"
import script from "./theme.vue?vue&type=script&lang=ts&"
export * from "./theme.vue?vue&type=script&lang=ts&"
import style0 from "./theme.vue?vue&type=style&index=0&id=51791272&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51791272",
  null
  
)

export default component.exports